import { useHistory } from "react-router-dom";
import { AdminLayout } from "../components/AdminLayout";
import { XForm } from "../components/Form";
import { ScreenHeader } from "../components/ScreenHeader";

import * as service from "../services/wystawy.service";

export const CreateWystawyScreen = () => {
  const history = useHistory();

  return (
    <AdminLayout>
      <>
        <ScreenHeader
          withBackButton
          breadcrumbs={["Panel CMS", "Wystawy", "Stwórz"]}
        />

        <XForm
          onSubmit={(data) => {
            service.createWystawyItem(data).then((_) => history.goBack());
          }}
        />
      </>
    </AdminLayout>
  );
};
